import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
    UserPoolId: "us-east-1_chhn20JiM",
    ClientId: "5van2uivlqqll59pl603s1762f"
}

const userPool = new CognitoUserPool(poolData);

export default userPool;
